import type {ReactNode} from 'react'
import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS, MARKS} from '@contentful/rich-text-types'
import type {Document} from '@contentful/rich-text-types'
import {InlineCode} from '@primer/react-brand/esm'

export const codeMarkRenderer = {
  [MARKS.CODE]: (children: ReactNode) => <InlineCode wrap>{children}</InlineCode>,
}

/**
 * Renders the first paragraph node of a Contentful RichText document with inline code mark support.
 * All other nodes are silently ignored to enforce single-line content.
 * Used for headingRich fields (Card, CTABanner, River, Pillar) and description fields (Hero, CTABanner).
 *
 * @param document - The Contentful rich text document to render
 */
export function renderSingleLineRichText(document: Document): ReactNode {
  const firstParagraph = document.content.find(node => node.nodeType === BLOCKS.PARAGRAPH)
  const singleParagraphDoc: Document = {
    ...document,
    content: firstParagraph ? [firstParagraph] : [],
  }
  return documentToReactComponents(singleParagraphDoc, {
    renderMark: codeMarkRenderer,
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
    },
  })
}
